import Link from 'components/link/Link';

import { ILink } from 'source/NFR.types';

const DateCardTagsItem = (props: ILink) => (
  <div className="date-card-tags-item" key={props.text + props.url}>
    <Link theme="tag" {...props} />
  </div>
);

DateCardTagsItem.displayName = 'DateCardTagsItem';

export default DateCardTagsItem;
